<template>
  <div class="align">{{lineAmount | formatLineAmount}}</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnLineAmount',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  created () {
    const line = this.line(this.rowId)
    this.localQty = line.quantity || 0
    this.localPrice = line.price || 0
    this.bus.$on(`line-qty-changed-${this.rowId}`, (qty) => this.localQty = qty)
    this.bus.$on(`line-price-changed-${this.rowId}`, (price) => this.localPrice = price)
  },
  data () {
    return {
      localQty: 0,
      localPrice: 0
    }
  },
  computed: {
    ...mapGetters({
      line: 'edit/line'
    }),
    lineAmount () {
      return this.localQty * this.localPrice
    }
  },
  filters: {
    formatLineAmount (val) {
      return (Math.round(val * 100) / 100) || ''
    }
  },
  beforeDestroy () {
    this.bus.$off(`line-qty-changed-${this.rowId}`)
    this.bus.$off(`line-price-changed-${this.rowId}`)
  },
  inject: ['bus']
}
</script>

<style lang="scss" scoped>
.align {
  text-align:right
}
</style>
